import React, {useState} from "react";
import { useRouter } from 'next/router';
import { authlogin, validationEmail } from '../../lib/api/auth';
import Loader from '../../components/loader';
import { notifyMe } from "../../helper";
import {  useRecoilState } from "recoil";
import { userState } from '../../atoms/store';
import { setCookies, removeCookies } from 'cookies-next';
import Link from 'next/link';
import { Popconfirm, message } from 'antd';
import { getprofile } from '../../lib/api/myspace';
import { Input, Space } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import SocialLoginButton from './SocialLoginButtons.jsx';
import withCart from "../../lib/withCart";
import ValidationResend from "../../pages/auth/validation_resend";

const LoginComponent = ({path, findCart}) => {
    const router = useRouter();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isBackdropVisible, setBackdropVisibility] = useState(false);
    const [userDataStored, setUserDataStored] = useRecoilState(userState);
    const authToken = !!userDataStored


    const cancel = (e) => {
        return false;
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            submitLogin(email, password)
        }
    }

    const submitLogin = async (emailval, passwordval) => {
        

        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailval == '') {
        notifyMe({ key: 'signIn', method: 'error', message: 'Error', description: 'El email es obligatorio' });
        return false;
        }
        if (pattern.test(emailval) == false) {
        notifyMe({ key: 'signIn', method: 'error', message: 'Error', description: 'El email no parece válido' });
        return false;
        }

        if (passwordval == '') {
        notifyMe({ key: 'signIn', method: 'error', message: 'Error', description: 'La contraseña es necesaria' });
        return false;
        }

        if (emailval != '' && passwordval != '') {

        try {

            setBackdropVisibility(true);

            const obj = {"email":  Buffer.from(emailval).toString('base64'), "password": Buffer.from(passwordval).toString('base64'), "type":0};
            const response = await authlogin(obj);

            if (response.success === true) {
                setBackdropVisibility(false);
                setCookies('eccauthToken', response.data.authToken,{ maxAge: 60 * 60 * 24 * 30});

                const resp = await getprofile();
                if(!resp.success) {
                    notifyMe({ key: 'signIn', method: 'error', message: 'Fallo en Login', description: 'Usuario desconocido' });
                    return;
                }
                
                setUserDataStored(resp.data);

                notifyMe({ key: 'signIn', method: 'success', message: 'Login Correcto', description: 'Bienvenido de nuevo!' });

                await findCart();

                if(path == 'miespacio'){
                    router.push('/');
                }
                else
                {
                    router.push('/checkout/step3');
                }
                return;
            } else {
              if(response.responseCode === 141)
              {
                //  setUserNotValidated('1');
                    //router.push('/auth/validation_resend');
            
                    router.push({
                    pathname: '/auth/validation_resend',
                    query: { email: email}
                }, '/auth/validation_resend')
              }
              else {
                setBackdropVisibility(false);
                notifyMe({ key: 'signIn', method: 'error', message: 'Error en el login', description: 'Verifica que el email y contraseña sean correctos' });
                return;
              }

            }

        } catch (err) {
            setBackdropVisibility(false);
            notifyMe({ key: 'signIn', method: 'error', message: 'Error en login', description: 'Ha ocurrido un error, vuelve a intentarlo más tarde.' });
            return;
        }

        }
    };

        const confirmsignUp = () => {
            clearSession(`/auth/register${path == 'cart' ? '?path=cart' : ''}`)
        }

        const confirm = (email, password) => {
            clearSession();
            submitLogin(email, password);
        }

        const clearSession = (redirect) =>{
            window.localStorage.clear();
            removeCookies('eccauthToken');
            setUserDataStored(null);
            if(redirect){
                router.push(redirect)
            }
        }

        return (
        <div className="container innerpage main-container mt-50">
            <div className="registrar">
            <h2 className="A-la-venta-esta-sema">Accede a tu cuenta</h2>
            <div className="line4"></div>
            <div className="form cont_form_2">
                <h4>E-mail *</h4>
                <input type="text" name="email" onChange={(event) => setEmail(event.target.value)} />
                <h4>Contraseña *</h4>
                <Input.Password
                            name="password"
                            onKeyDown={handleKeyDown}
                                onChange={(event) => setPassword(event.target.value)}
                                placeholder="Pon tu contraseña"
                                iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                />
                {path == 'cart' && authToken ?
                <Popconfirm
                    title="¿Estás seguro? Si continúas perderás tu progreso"
                    onConfirm={() => confirm(email, password)}
                    onCancel={cancel}
                    okText="Sí"
                    cancelText="No"
                >
                    <Link href="#"><a className="btn2_cont mt-20 login">Acceder</a></Link>
                </Popconfirm>
                : <button className="btn2_cont mt-20 login" onClick={() => submitLogin(email, password)}>Acceder</button>
                }

                <div className="clearfix"></div>
                <h3><i><Link href='/auth/forgotpassword' passHref={true}>¿Has olvidado la contraseña?</Link></i></h3>
                <div className="clearfix"></div>
                <div className="goo-face-lft">
                <h3>¿Aún no tienes cuenta?</h3>
                {path == 'cart' && authToken ?
                <Popconfirm
                    title="¿Estás seguro? Si continúas perderás tu progreso"
                    onConfirm={() => confirmsignUp()}
                    onCancel={cancel}
                    okText="Sí"
                    cancelText="No"
                >
                    <button className="btn2_cont mt-20" >Crea una cuenta</button>
                </Popconfirm>
                :
                <button className="btn2_cont" onClick={()=>{  router.push(`/auth/register${path == 'cart' ? '?path=cart' : ''}`) }}>Crea una cuenta</button>
                }
                </div>
                <div className="goo-face-rht">
                <h3><b>Ingresa o accede en un click</b></h3>
                <SocialLoginButton path={path} findCart= {findCart} setUserDataStored={setUserDataStored}/>
                <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
            </div>
            </div>
        </div>
        )
    }

export default withCart(LoginComponent);
